<template>
  <div
    class="form-submission-block p-relative"
    :style="{ padding: blockPadding }"
  >
    <template v-if="isBuilderContext()">
      <block-placeholder icon="assignment_turned_in" text="Form Submissions" />
    </template>

    <grouped-form-submissions
      v-else
      :block-id="blockId"
      :channel-id="channelId"
      :empty-description="
        $t('components.blocks.formSubmissionBlock.emptyDescription')
      "
      class="p-1"
      @choose="chooseSubmission"
    />
  </div>
</template>

<script>
import { toPadding } from "@shared/block-ratio"
import { isBuilderContext } from "@/lib/utils"

import GroupedFormSubmissions from "@/components/form-submission/GroupedFormSubmissions"

export default {
  components: {
    GroupedFormSubmissions,
    BlockPlaceholder: () => import("@/components/stream/BlockPlaceholder")
  },

  props: {
    blockId: { type: [String, Number], default: null },
    channelId: { type: String, default: null },
    spaceXRatio: { type: Number, default: 0 },
    spaceTopRatio: { type: Number, default: 0 },
    spaceBottomRatio: { type: Number, default: 0 }
  },

  computed: {
    blockPadding() {
      return toPadding(
        this.spaceTopRatio,
        this.spaceXRatio,
        this.spaceBottomRatio
      )
    }
  },

  methods: {
    isBuilderContext,

    chooseSubmission(submission) {
      this.$router.push(
        `/me/forms/${submission.form.id}/submissions/${submission.id}`
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";
@import "@/assets/styles/mixins";

.form-submission-block {
  @include container;

  padding-bottom: $size--11;

  .block-placeholder {
    height: 250px;
  }
}
</style>
